import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { ChangeEvent } from 'react';
import { CROSS_FADE_DURATION, setFilterVolume } from '../../domain/audio-provider';

const RadioButtons = () => {

    const dispatch = useAppDispatch();

    const audioContext = useAppSelector(store => store.root.audioContext);
    const selected = useAppSelector(store => store.root.selected);
    const isBypass = useAppSelector(store => store.root.isBypass);
    const isDelta = useAppSelector(store => store.root.isDelta);
    const data = useAppSelector(store => store.root.data);

    const hideDelta = data?.settings?.hideDelta ?? false;
    const crossFadeDuration = data?.settings?.crossFadeDuration ?? CROSS_FADE_DURATION;

    const onChange = (evt: ChangeEvent<HTMLInputElement>) => {

        switch (evt.target.value) {
            case 'bypass': {
                setFilterVolume(audioContext, selected, true, false, crossFadeDuration);

                dispatch(
                    rootActions.main({
                        isBypass: true,
                        isDelta: false,
                    })
                );
                break;
            }

            case 'delta': {
                setFilterVolume(audioContext, selected, false, true, crossFadeDuration);

                dispatch(
                    rootActions.main({
                        isBypass: false,
                        isDelta: true,
                    })
                );
                break;
            }

            default: {
                setFilterVolume(audioContext, selected, false, false, crossFadeDuration);

                dispatch(
                    rootActions.main({
                        isBypass: false,
                        isDelta: false,
                    })
                );
                break;
            }
        }
    };

    return (
        <div className="flex items-center">
            <label className="flex items-center mr-4 md:mr-10 cursor-pointer">
                <input
                    type="radio"
                    name="iq-player-settings"
                    checked={!isBypass && !isDelta}
                    value="on"
                    onChange={onChange}
                    className="mr-2"
                />
                <span>On</span>
            </label>

            <label className="flex items-center mr-4 md:mr-10 cursor-pointer">
                <input
                    type="radio"
                    name="iq-player-settings"
                    checked={isBypass}
                    value="bypass"
                    onChange={onChange}
                    className="mr-2"
                />
                <span>Bypass</span>
            </label>

            {
                !hideDelta &&
                <label className="flex items-center cursor-pointer">
                    <input
                        type="radio"
                        name="iq-player-settings"
                        checked={isDelta}
                        value="delta"
                        onChange={onChange}
                        className="mr-2"
                    />
                    <span>Delta</span>
                </label>
            }
        </div>
    )
};

export default RadioButtons;